<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-invest-icon01.svg" alt="*" />あなたの自己投資マインド
				</span>
			</div><!-- end .type -->
			<div class="cover">
				変革型{{investMindResult.percentageLeft}}%、保守型{{investMindResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>投資マインドを自らの外向性とマッチさせることで、自己投資のリターンはこれからもっと大きくなる</h2>
			<img src="../assets/result-detail-invest-outright01.svg" alt="*" class="visual" />
			<div class="caption">
				思慮深く考えること仇になることがあり、軽いノリで感覚的に動くほうが投資の結果は上向く傾向にある
			</div><!-- end .caption -->
			<p>2番目は自己投資の特性を診断しました。なぜなら、内向性の高い人ほど、自己投資で受けられるリターンが非常に大きくなる可能性を秘めているからです。</p>
			<p>外向的な人は、物事の本質を掴むことよりも、表に見えることを信じ抜くことに長けています。内向的な人が物事の裏側を読み解こうとしている間に、外向的な人は「これだ！」と決め込んだものがあれば、それに即座に投資する行動体質を持っていると言えるでしょう。</p>
			<p>あなたの自己投資は保守型{{investMindResult.percentageRight}}%という結果は、あなたは高い外向性を持ちつつも、投資に関しては冷静かつ慎重な姿勢を取ることが分かりました。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自身の直感を信じたうえで、自分の保守的なマインドに打ち克つ</h2>
			<img src="../assets/result-detail-invest-outright02.svg" alt="*" class="visual" />
			<div class="caption">
				ピンときた物事に対しては、積極性を出す機会を少しずつ増やしていくべきだ
			</div><!-- end .caption -->
			<p>外向性が高いあなたは、外向きの活動が多くなります。そのため、様々な人や分野に関りをもつことができます。こうした外向的な活動は、あなたに多様な自己投資のチャンスをもたらしてくれます。</p>
			<p>そして、あなたは自己投資に保守的な傾向があります。投資を雑に行わずに、丁寧に行う資質があるのです。上手に外向性を働かせれば、あなたは様々なものを慎重に分析していくようになるでしょう。そして、「これだ！」と思ったものに見定めて、投資を行っていくでしょう。</p>
			<p>上記の課題がクリアできれば、あなたは、絶好のチャンスが巡りやすく、そのチャンスを逃さない体質になっていきます。切れるようになります。お金やリスクが必要ない場面でも、新しい感覚や初体験を積極的に取り入れるよういしてみて下さい。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>外向性の多様性こそが、あなたの投資結果を大きく引き上げる</h2>
			<img src="../assets/result-detail-invest-outright03.svg" alt="*" class="visual" />
			<div class="caption">
				多動することそのものが、自分の保守的な欠点を自然に排除してくれる
			</div><!-- end .caption -->
			<p>このタイプで注意したいのが、1つのコミュニティや投資先へ過度に依存してしまうことです。投資タイプが保守型なので、一度投資にコミットすると、「その投資で完結してしまいたい」という感情が芽生えてしまいます。</p>
			<p>保守型は、決定を下す前までは非常に慎重ですが、一度決定を下した後は、その決定に安心してしまい、その他の視点や意見を閉ざしてしまう傾向があります。外向性が高いため、１つのコミュニティへどんどん参加し、自分自身で依存心を強めてしまうのです。</p>
			<p>自己投資が保守型で外向性が高いあなたの場合、自分の外向性に多様性を持たせることが、一番の有益な自己投資と言えます。</p>
			<p>同時に複数の分野に自己投資する、同時に複数のコミュニティに所属する、といった感じです。多様なヒト・モノ・コトに触れることで、比較対象を多様に広げることができます。自分の価値観と違うものを、反対のものに興味を持つ意識も、あなたを大きく変えてくれます。</p>
			<p>自己投資が保守型の人は、ドツボにハマると、自分の枠の中で何でも同じことを繰り返し、その枠から飛び出す発想すらなくなってしまいます。ですから、普段から、自分の外向的行動に多様性を持たせることで、事前に大きなピンチになることを防ぎ、適切なチャンスがより多く集まってくるようになるのです。</p>
		</div><!-- end .sentence -->
</div><!-- end .contents -->				
</template>

<script>


export default {
	name: 'ResultDetailInvestOutRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},		
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
